<h1 mat-dialog-title [attr.data-cy]="'bpp_h1_1_4_'">Produktionsabschnitte {{ betriebsart.bezeichnung }}</h1>
<div mat-dialog-content>
    <div class="info-box"> Bitte die Produktionsabschnitte in der entsprechenden Reihenfolge eintragen</div>
    <div class="one-row">
        <span class="spacer" [attr.data-cy]="'bpp_span_1_16_'"></span>
        <button
            style="margin-bottom: 12px"
            mat-icon-button
            color="accent"
            (click)="addOrEdit()"
            [attr.data-cy]="'bpp_button_1_0_'"
        >
            <mat-icon [attr.data-cy]="'bpp_mat-icon_1_2_'">add</mat-icon>
        </button>
    </div>

    <p *ngIf="!betriebsart?.produktionsabschnitte || betriebsart?.produktionsabschnitte?.length === 0"
        >Keine Produktionsabschnitte hinterlegt</p
    >
    <ul
        *ngIf="betriebsart?.produktionsabschnitte?.length > 0"
        cdkDropList
        class="list"
        (cdkDropListDropped)="drop($event)"
    >
        <li class="one-row box" *ngFor="let abschnitt of betriebsart?.produktionsabschnitte; let i = index" cdkDrag>
            <mat-icon [attr.data-cy]="'bpp_mat-icon_2_2_ + i'">drag_handle</mat-icon>
            <span [attr.data-cy]="'bpp_span_2_16_' + i">{{ i + 1 }}. {{ abschnitt?.produktionsabschnitt }}</span>
            <span class="spacer" [attr.data-cy]="'bpp_span_3_16_' + i"></span>
            <span [attr.data-cy]="'bpp_span_4_16_' + i"
                >Schlachtgrenze: {{ abschnitt?.schlachtgrenze ? abschnitt.schlachtgrenze + " Tage, " : "" }}
                {{ abschnitt?.schlachtgrenze_monate ? abschnitt.schlachtgrenze_monate + " Monate" : "" }}</span
            >
            <span class="spacer" [attr.data-cy]="'bpp_span_5_16_' + i"></span>
            <button
                mat-icon-button
                color="accent"
                [matMenuTriggerFor]="abschnittMenu"
                [attr.data-cy]="'bpp_button_2_0_' + i"
            >
                <mat-icon [attr.data-cy]="'bpp_mat-icon_3_2_' + i">more_vert</mat-icon>
            </button>
            <mat-menu #abschnittMenu>
                <button mat-menu-item (click)="addOrEdit(abschnitt)" [attr.data-cy]="'bpp_button_3_0_' + i">
                    <mat-icon [attr.data-cy]="'bpp_mat-icon_4_2_' + i">edit</mat-icon>
                    <span [attr.data-cy]="'bpp_span_6_16_' + i">bearbeiten</span>
                </button>
            </mat-menu>
        </li>
    </ul>
</div>
<div mat-dialog-actions>
    <span class="spacer" [attr.data-cy]="'bpp_span_7_16_'"></span>
    <button mat-button (click)="cancel()" [attr.data-cy]="'bpp_button_4_0_'">Abbrechen</button>
    <button mat-flat-button color="accent" (click)="save()" [attr.data-cy]="'bpp_button_5_0_'">Speichern</button>
</div>
